import { CopyButtonWithLabel } from '@/components/CopyButton';
import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { FC, memo, useMemo } from 'react';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type CopyLinkButtonProps = {
  sharePath?: string;
};

/**
 * Same behavior as business_documents' CopyURLButton (shows "copied" for
 * only 2 seconds).
 */
export const CopyLinkButton: FC<CopyLinkButtonProps> = memo(({ sharePath }) => {
  const { t } = useTranslation();
  const shareUrl = useMemo(
    () => (sharePath ? new URL(sharePath, location.origin).toString() : ''),
    [sharePath]
  );

  return (
    <CopyButtonWithLabel
      size='sm'
      isSecondary
      omitLeftIconPadding
      buttonContainerClassName={cx('button')}
      text={shareUrl}
      isDisabled={!shareUrl}
      copyLabel={t('invoice_report_share.copy_link')}
      copiedLabel={t('invoice_report_share.copy_link_copied')}
      resetMilliSecond={2000}
      testId='admin-invoice-report-share-copy-link-button'
    />
  );
});
CopyLinkButton.displayName = 'CopyLinkButton';
